module.exports = __webpack_public_path__ + "img/logo1.bfe38678.png";